import { Breadcrumb } from "antd";
import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import { VariationBig } from "../Variation";
import { ComponentContainer, LayoutGrid } from "../LayoutContainers";
import BuySellValuesTable from "../Tables/BuySellValuesTable";
import BadgeTag from "../BadgeTags";
import { __ } from "../../locales/translation";
import { fetchMarketStatus } from "../../utils/fetchers";

export default function HeroProductDetail({ item }) {
    const { productType, productId } = useParams();

    const {
        cantidadCompra,
        cantidadVenta,
        horaUltimaNovedad,
        logo,
        moneda,
        precioMejorOrdenCompra,
        precioMejorOrdenVenta,
        precioUltimaOperacion,
        simbolo,
        variacion,
        descripcion,
    } = item || {};

    const { data: marketStatusData, isLoading: isLoadingMarketStatus } = useQuery({
        queryKey: ["marketStatus"],
        queryFn: fetchMarketStatus,
        refetchOnReconnect: true,
    });

    return (
        <ComponentContainer image={`${window._env_.STATIC_HOST}/static/website/images/hero-cot-product.jpg`}>
            <LayoutGrid spacingTop="0" spacingBottom="0" cols={1}>
                <div className="cot-hero-product-detail">
                    <Breadcrumb
                        items={[
                            {
                                title: (
                                    <Link data-external-check-exempt to="/">
                                        {__("Inicio")}
                                    </Link>
                                ),
                            },
                            {
                                title: (
                                    <Link data-external-check-exempt to={`/${productType}`}>
                                        {__(productType)}
                                    </Link>
                                ),
                            },
                            {
                                title: productId,
                            },
                        ]}
                    />

                    <div className="content-wrapper">
                        <div className="cot-product-name">
                            {logo && <img className="ticker-logo" src={logo} alt={simbolo} />}

                            <div className="data-wrapper">
                                <h1 className="title-2">{descripcion || simbolo}</h1>
                                {descripcion && <h4 className="title-5">{simbolo}</h4>}

                                {/* {item.isMaxCapital ? <Pill type="highlighted" /> : null} */}
                            </div>
                        </div>

                        <div className="product-info-values-wrapper">
                            <div className="cot-product-value">
                                <div className="value-wrapper">
                                    <span className="small-text">{moneda}</span>{" "}
                                    <span className="title-3">{precioUltimaOperacion}</span>
                                </div>

                                <VariationBig value={variacion} />
                            </div>

                            <div className="divider"></div>

                            <div className="buy-sell-table">
                                <BuySellValuesTable
                                    cantidadCompra={cantidadCompra}
                                    cantidadVenta={cantidadVenta}
                                    precioCompra={precioMejorOrdenCompra}
                                    precioVenta={precioMejorOrdenVenta}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="cot-hero-footer">
                        <div className="refresh-content">
                        <span className="small-text">
                            {
                                productType.toLowerCase() === "fondos" ?
                                __("Fuente") + " CAFCI" :
                                __("Fuente") + " BYMA"
                            }
                        </span>


                            {/* dot */}
                            <svg width="2" height="2" viewBox="0 0 2 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="1" cy="1" r="1" fill="currentColor" fillOpacity="0.7" />
                            </svg>

                            <span className="small-text">{__("Actualización")}</span>

                            {/* dot */}
                            <svg width="2" height="2" viewBox="0 0 2 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="1" cy="1" r="1" fill="currentColor" fillOpacity="0.7" />
                            </svg>

                            <span className="small-text">{horaUltimaNovedad}</span>
                        </div>

                        <div className="badge-container">
                            <p className="paragraph">{ }</p>
                            <BadgeTag type={marketStatusData?.abierto ? "open-market" : "close-market"} marketTag />
                        </div>
                    </div>
                </div>
            </LayoutGrid>
        </ComponentContainer>
    );
}
